// src/hooks/useCreateConversation.js
import { useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/**
 * Cria um atendimento (POST /conversations) e devolve o resumo { id, name, ... }.
 * Exponho createConversation (mutateAsync) + flags alinhadas ao seu useChatState.
 */
export const useCreateConversation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (payload) => {
      const resp = await fetchData("/conversations", "POST", payload);
      // fetchData normaliza { data, pagination }. Queremos só o payload de data:
      return resp?.data;
    },
    {
      onSuccess: () => {
        // Atualiza lista de conversas
        queryClient.invalidateQueries(["conversations"]);
      },
      onError: (err) => {
        console.error("❌ Erro ao criar atendimento:", err);
      },
    }
  );

  return {
    // API esperada pelo seu useChatState:
    createConversation: mutation.mutateAsync,
    isCreating: mutation.isLoading,
    errorCreating: mutation.error,
    createdConversation: mutation.data,
    resetCreateConversation: mutation.reset,
  };
};
